import { isProductPage } from 'models/ProductPageModel';
import { PageState } from 'models/PageState';

export const getAddons = ({ currentPage }: PageState) =>
  isProductPage(currentPage) ? currentPage.addons : undefined;

export const isFamily = ({ currentPage }: PageState) =>
  isProductPage(currentPage) && currentPage.product.isFamily;
